import React from 'react';
import { useLocation, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UnauthorizedPage = () => (
  <div style={{ padding: '40px', textAlign: 'center', background: 'var(--bg-secondary)', borderRadius: '8px', margin: '50px auto', maxWidth: '600px' }}>
    <h1 style={{ fontSize: '2.5rem', color: 'var(--text-primary)' }}>权限不足</h1>
    <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', marginBottom: '30px' }}>抱歉，您没有权限访问此页面。</p>
    <Link 
      to="/" 
      style={{ 
        padding: '12px 24px', 
        background: 'var(--primary-color)', 
        color: 'white', 
        textDecoration: 'none', 
        borderRadius: '6px',
        fontWeight: '600'
      }}
    >
      返回首页
    </Link>
  </div>
);

const ProtectedRoute = ({ children, permissions }) => {
  const { isAuthenticated, hasPermission, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // 在验证用户信息时显示加载状态，避免页面闪烁
    return <div>正在加载...</div>;
  }

  if (!isAuthenticated) {
    // 用户未登录，重定向到登录页，并保存当前意图访问的地址
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果路由需要特定权限，而用户不具备，则显示无权限页面
  // 修改为只要拥有其中任意一个权限即可访问
  if (permissions) {
    const permArray = Array.isArray(permissions)? permissions : [permissions];
    const any = permArray.some(p => hasPermission([p]));
    if(!any){
      return <UnauthorizedPage />;
    }
  }

  // 用户已登录且具备所需权限（或路由无需特定权限），渲染子组件
  return children;
};

export default ProtectedRoute;
